import React from 'react'
import { Conatiner } from './styles'

const FallbackPage = () => {
  return <Conatiner>Loading...</Conatiner>
}

export default FallbackPage
